import NavActions from './NavActions'
import NavRoutes from './NavRoutes'
import type { FC } from 'react'
import type { NavAction, StoreState } from '../../framework/microAppTypes'

interface AppBarProps {
  state: StoreState
  actions: NavAction[]
  isSideNavCollapsed: boolean
  hideNavRoutes: boolean
  hasFawkes: boolean
}
const AppBar: FC<AppBarProps> = ({ state, actions, hideNavRoutes, ...props }) => {
  return (
    <div className={`sparky-app-nav spf-flex spf-flex-col spf-w-full spf-h-full ${props.isSideNavCollapsed ? 'collapsed' : 'expanded'}`}>
      {!hideNavRoutes && <NavRoutes {...props} />}
      <NavActions {...props} hideNavRoutes={hideNavRoutes} actions={actions} state={state} />
    </div>
  )
}

export default AppBar
